<template>
  <slice
    :id="block._key"
    class="block--line-of-blocks"
    :style="{
      '--number-of-blocks': block.blocks.length,
    }"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <blocks
      v-if="block.blocks && block.blocks.length > 0"
      :blocks="block.blocks"
      :entities="entities"
      :is-home="isHome"
      :is-on-top-of-page="isOnTopOfPage"
      :origin="origin"
    />
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import Blocks from '@/components/blocks/Blocks'
import { ORIGIN } from '~/const'

export default {
  name: 'LineOfBlocksBlock',
  components: { Slice, Blocks },
  props: {
    block: { type: Object, required: true },
    entities: {
      type: Object,
      default: () => {},
    },
    isHome: {
      type: Boolean,
      default: false,
    },
    isOnTopOfPage: {
      type: Boolean,
      default: false,
    },
    origin: { type: String, default: ORIGIN.PAGE },
  },
}
</script>

<style lang="scss">
.block--line-of-blocks {
  .blocks {
    @include mq($from: tablet) {
      display: grid;
      grid-template-columns: repeat(var(--number-of-blocks), 1fr);
    }

    > .slice,
    > .block {
      margin: 0;
      max-width: 100%;
    }

    .slice--video {
      padding: 0;
    }

    .slice--title {
      h2 {
        text-align: left;
      }
    }

    .row-md:not(.traceability__item) {
      display: block;
    }

    .slice--texte {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      padding: calc(var(--spacing) * 2) var(--spacing);

      @include mq($from: tablet) {
        padding: calc(var(--spacing) * 4) calc(var(--spacing) * 2);
      }

      > * {
        width: 100%;
      }
    }

    // .blocks--gallery {
    // --block-width: calc(100vw - var(--purchase-sticky-width));
    // --row-portrait: calc(var(--block-width) * (5 / 4));
    // --row-landscape: calc(var(--block-width) * (4 / 5));
    // --row-two: calc(var(--block-width) * (5 / 8));
    // --row-three: calc(var(--block-width) * (5 / 12));

    // background-color: white;

    // @include mq($from: tablet) {
    //   display: grid;
    //   grid-auto-columns: minmax(0, 1fr);
    //   grid-auto-flow: column;
    //   grid-template-rows: var(--gallery-rows, auto);

    //   > * {
    //     grid-column: var(--grid-column);
    //     grid-row: var(--grid-row);
    //   }
    // }
    // }
  }
}
</style>
